module.exports = __webpack_public_path__ + "static/media/AltitudeIcon.42a4e5c1.svg";